const projectData = () => ({
    targets: [
        {
            isStage: true,
            name: "Stage",
            variables: {},
            lists: {},
            broadcasts: {},
            customVars: [],
            blocks: {},
            comments: {},
            currentCostume: 0,
            costumes: [
                {
                    name: "backdrop1",
                    dataFormat: "svg",
                    assetId: "cd21514d0531fdffb22204e0ec5ed84a",
                    md5ext: "cd21514d0531fdffb22204e0ec5ed84a.svg",
                    rotationCenterX: 240,
                    rotationCenterY: 180,
                },
            ],
            sounds: [],
            id: "LK}C!(@yZElE6p}U#WRS",
            volume: 100,
            layerOrder: 0,
            tempo: 60,
            videoTransparency: 50,
            videoState: "on",
            textToSpeechLanguage: null,
        },
        {
            isStage: false,
            name: "Penguin",
            variables: {},
            lists: {},
            broadcasts: {},
            customVars: [],
            blocks: {},
            comments: {},
            currentCostume: 0,
            costumes: [
                {
                    name: "confused",
                    bitmapResolution: 1,
                    dataFormat: "svg",
                    assetId: "c782f2ee964beabce6c167a8f96ca052",
                    md5ext: "c782f2ee964beabce6c167a8f96ca052.svg",
                    rotationCenterX: 43.95154930493305,
                    rotationCenterY: 58.25742438569469,
                },
            ],
            sounds: [],
            id: "=wTWCF[AE*cqY%]Eh{E=",
            volume: 100,
            layerOrder: 2,
            visible: true,
            x: 0,
            y: -40,
            size: 150,
            direction: 90,
            draggable: false,
            rotationStyle: "all around",
        },
        {
            isStage: false,
            name: "Text",
            variables: {},
            lists: {},
            broadcasts: {},
            customVars: [],
            blocks: {},
            comments: {},
            currentCostume: 0,
            costumes: [
                {
                    name: "costume1",
                    bitmapResolution: 1,
                    dataFormat: "svg",
                    assetId: "ae1546a5b361ee39fef852e385e47e18",
                    md5ext: "ae1546a5b361ee39fef852e385e47e18.svg",
                    rotationCenterX: 144.52295041351317,
                    rotationCenterY: 21.93419499999999,
                },
            ],
            sounds: [],
            id: "l|nDdOJ4*Zf5IgzXB5!Y",
            volume: 100,
            layerOrder: 1,
            visible: true,
            x: 0,
            y: 80,
            size: 100,
            direction: 90,
            draggable: false,
            rotationStyle: "all around",
        },
    ],
    monitors: [],
    extensionData: {},
    extensions: [],
    meta: { semver: "3.0.0", vm: "0.2.0", agent: "" },
});

export default projectData;
